import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {
  QueryResult,
  QueryOptions,
  ProcessResult,
  QueryResultItem,
} from '../components/common-dto/query.dto';
import { PostDto } from '../dto/post.dto';

@Injectable({
  providedIn: 'root',
})
export class MockPostService {
  private mockPosts: PostDto[] = [
    {
      id: '1',
      content: 'This is a sample post content',
      categories: ['IT', 'Construction'],
      mediaUrl: 'https://example.com/video.mp4',
      mediaType: 'video',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ];

  getPosts(queryParams: QueryOptions): Observable<QueryResult<PostDto>> {
    const skip = queryParams.skip || 0;
    const take = queryParams.take || 10;
    const filtered = this.mockPosts.slice(skip, skip + take);

    const result: QueryResult<PostDto> = {
      items: filtered.map((post) => ({
        id: post.id || '',
        item: post,
      })),
      total: this.mockPosts.length,
      skip,
      take,
    };

    return of(result).pipe(delay(300));
  }

  getPost(id: string): Observable<PostDto> {
    const post = this.mockPosts.find((p) => p.id === id);
    if (post) {
      return of(post).pipe(delay(200));
    }
    return of({
      id: id,
      content: '',
      categories: [],
    } as PostDto).pipe(delay(200));
  }

  createPost(post: PostDto): Observable<ProcessResult> {
    const newPost: PostDto = {
      ...post,
      id: Date.now().toString(),
      createdAt: new Date(),
      updatedAt: new Date(),
    };
    this.mockPosts.unshift(newPost);

    return of({
      id: newPost.id || '',
      success: true,
      message: 'Post created successfully',
    }).pipe(delay(300));
  }

  updatePost(id: string, post: PostDto): Observable<ProcessResult> {
    const index = this.mockPosts.findIndex((p) => p.id === id);
    if (index !== -1) {
      this.mockPosts[index] = {
        ...post,
        id,
        updatedAt: new Date(),
      };
      return of({
        id,
        success: true,
        message: 'Post updated successfully',
      }).pipe(delay(300));
    }
    return of({
      id,
      success: false,
      message: 'Post not found',
    }).pipe(delay(300));
  }

  deletePost(id: string): Observable<ProcessResult> {
    const index = this.mockPosts.findIndex((p) => p.id === id);
    if (index !== -1) {
      this.mockPosts.splice(index, 1);
      return of({
        id,
        success: true,
        message: 'Post deleted successfully',
      }).pipe(delay(300));
    }
    return of({
      id,
      success: false,
      message: 'Post not found',
    }).pipe(delay(300));
  }

  uploadPostMedia(postId: string, file: File): Observable<ProcessResult> {
    // Mock upload - in real implementation, this would upload the file
    return of({
      id: postId,
      success: true,
      message: 'Media uploaded successfully',
    }).pipe(delay(500));
  }
}

